import React, { Component } from "react";
import { Route } from "react-router-dom";
import Admin from "./admin/Admin";
import Header from "./includes/Header";
import Footer from "./includes/Footer";
import Home from "./pages/Home";
import Page from "./pages/Page";
import "./App.css";

class App extends Component {
  state = {
    loggedIn: false,
    signedOut: false,
    email: "",
    username: "",
    uid: ""
  };

  render() {
    return (
      <div className="App">
        <Header />
        <div className="App-content">
          <Route exact path="/" component={Home} />
          <Route
            path="/:page"
            render={() => (
              <main className="main frontend">
                <Page key={Math.random()} />
              </main>
            )}
          />
          <Route path="/admin" render={() => <Admin />} />
          <iframe id="invis" name="invis" title="invis" />
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js